/**
 * LoadingSkeleton - Animated placeholder block(s) with a pulse animation.
 *
 * Uses the `skeleton-pulse` keyframes defined in global.css. Renders `count`
 * blocks of the given width/height, useful as Suspense / data-loading fallbacks.
 */
interface LoadingSkeletonProps {
  width?: number | string;
  height?: number | string;
  count?: number;
  radius?: number | string;
}

export default function LoadingSkeleton({
  width = '100%',
  height = 20,
  count = 1,
  radius = 'var(--radius-sm)',
}: LoadingSkeletonProps) {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          style={{
            width,
            height,
            background: 'var(--bg-surface-1)',
            borderRadius: radius,
            animation: 'skeleton-pulse 1.5s ease-in-out infinite',
          }}
        />
      ))}
    </>
  );
}
